import InnoIcons from "InnoUI/innoicons";
import theme from "@theme";
import styled from "@emotion/styled";

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 80%;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #afafaf;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  height: 25px;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
  ,
  &::placeholder {
    color: #afafaf;
  }
`;

const Container = styled.div`
  overflow-y: scroll;
  max-height: 550px;
  padding: 0px 20px 20px 20px;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  font-size: 15px;
`;

const ThRole = styled.th`
  text-align: left;
  padding: 10px;
  display: flex;
  gap: 10px;
  text-align: center;
  align-items: center;
  font-size: 15px;
`;

const Trheader = styled.tr`
  border-bottom: 2px solid #ddd;
`;
const Tr = styled.tr``;

const TdRole = styled.td`
  padding: 0px 6px 0px 6px;
  border-bottom: 1px solid #ddd;
  font-size: 13px;
`;

const Td = styled.td`
  padding: 0px 6px 0px 6px;
  border-bottom: 1px solid #ddd;
`;

const Checkbox = styled.input`
  margin: 0;
`;

const SwapVertIcon = styled(InnoIcons.SwapVertIcon)`
  cursor: pointer;
  font-size: 16px;
`;

const Thead = styled.thead``;

const Tbody = styled.tbody``;

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.div`
  font-size: 17px;
  color: white;
  font-weight: normal;
  align-items: center;
  display: flex;
  text-align: center;
`;
const ThContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const SC = {
  InputContiner,
  SearchIcon,
  InputStyle,
  Container,
  Table,
  Th,
  Tr,
  Td,
  Checkbox,
  ThRole,
  SwapVertIcon,
  Thead,
  Tbody,
  TdRole,
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
  ThContainer,
  Trheader,
};

export default SC;
